import request from '@/utils/request'

export function sendValidCode (data) {
  return request({
    url: '/Register/SendValidCode',
    method: 'post',
    data
  })
}

export function submitRegInfo (data) {
  return request({
    url: '/Register/SubmitRegInfo',
    method: 'post',
    data
  })
}
